import React, { FC } from 'react';
import { Box } from '@wix/design-system';

interface Props {
  className: string;
  children: React.ReactNode;
}

const GalleryHeaderContainer: FC<Props> = ({ className, children }) => {
  return <Box className={className}>{children}</Box>;
};

export default GalleryHeaderContainer;
